import PropTypes from "prop-types";
import React, { Component } from "react";
import { Dialog, IconButton } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Trans } from "@lingui/macro";
import { withStyles } from "@material-ui/core";
import { alertDialog } from "../actions";
import { connect } from "react-redux";
import { goToBeginning, goToNextStep } from "../utils/scenario-manager";
import CloseIcon from "@material-ui/icons/Close";

const styles = () => ({
  dialog: {
    borderRadius: "15px",
    minWidth: "440px"
  }
});

class AlertDialog extends Component {
  state = {
    open: true
  };

  componentDidMount() {
    this.setState({ open: true });
  }

  handleClose = () => {
    this.setState({ open: false });
    if (this.props.isResetAlert) {
      this.props.resetAlert();
    }
    if (this.props.canGoToBeginning) {
      this.props.goToBeginning();
    } else if (this.props.canGoToNextStep) {
      this.props.goToNextStep();
    }
  };

  handleCloseButton = () => {
    this.setState({ open: false });
    if (this.props.handleClose) {
      this.props.handleClose();
    }
  };

  render() {
    const { classes } = this.props;
    const hideTitle = this.props.isHideTitle || false;
    const onClick = this.props.onClick ? this.props.onClick : this.handleClose;
    return (
      <React.Fragment>
        <Dialog
          aria-labelledby="priority-dialog-title"
          open={this.state.open || this.props.isOpen}
          onClose={onClick}
          classes={{
            paper: classes.dialog
          }}
          disableBackdropClick={
            this.props.isDisableBackdropClick ? true : false
          }
        >
          <DialogTitle className="head-dialog" id="priority-dialog-title">
            {this.props.closeButton && (
              <IconButton
                className="close-dialog"
                aria-label="close"
                onClick={this.handleCloseButton}
                style={{ color: "white", marginRight: "7px" }}
              >
                <CloseIcon />
              </IconButton>
            )}
            <div className="title-dialog">
              {!hideTitle && <i className="material-icons">warning</i>}
            </div>
          </DialogTitle>
          <div className="body-dialog dialog-s">
            <div
              className="text-dialog"
              dangerouslySetInnerHTML={{
                __html: this.props.message
                  ? this.props.message
                  : this.props.content
              }}
            />
            <div className="wrap-btn">
              <button className="custom-btn" onClick={onClick}>
                {this.props.btnText ? (
                  this.props.btnText
                ) : (
                  <Trans id="W_STEP_POPUP_BOUTON_OK" />
                )}
              </button>
            </div>
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}

AlertDialog.propTypes = {
  btnText: PropTypes.any,
  canGoToBeginning: PropTypes.any,
  canGoToNextStep: PropTypes.any,
  classes: PropTypes.shape({
    dialog: PropTypes.any
  }),
  closeButton: PropTypes.any,
  content: PropTypes.any,
  goToBeginning: PropTypes.func,
  goToNextStep: PropTypes.func,
  handleClose: PropTypes.func,
  isDisableBackdropClick: PropTypes.any,
  isHideTitle: PropTypes.bool,
  isOpen: PropTypes.any,
  isResetAlert: PropTypes.any,
  message: PropTypes.any,
  onClick: PropTypes.any,
  resetAlert: PropTypes.func
};

const mapStateToProps = state => ({
  canGoToBeginning: state.alertDialog.goToBeginning
    ? state.alertDialog.goToBeginning
    : "",
  canGoToNextStep: state.alertDialog.goToNext ? state.alertDialog.goToNext : "",
  message: state.alertDialog.content
});

const mapDispatchToProps = dispatch => ({
  resetAlert: () => dispatch(alertDialog(null)),
  goToBeginning: () => dispatch(goToBeginning()),
  goToNextStep: () => dispatch(goToNextStep())
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AlertDialog)
);
